import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-[#0f1923] border-t border-white/10 px-5 py-4 md:py-3">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6">
        <p className="font-body text-white/60 text-xs leading-relaxed flex-1">
          Bu site, temel işlevler için zorunlu çerezler kullanmaktadır.{' '}
          <Link to="/cerez-politikasi" className="text-[#d4a853] hover:underline underline-offset-2">
            Çerez Politikası
          </Link>{' '}
          ve{' '}
          <Link to="/kvkk" className="text-[#d4a853] hover:underline underline-offset-2">
            KVKK Aydınlatma Metni
          </Link>
        </p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={reject}
            className="font-body text-xs text-white/40 hover:text-white/70 transition-colors px-3 py-2 cursor-pointer"
          >
            Reddet
          </button>
          <button
            onClick={accept}
            className="font-body text-xs font-semibold bg-[#d4a853] text-[#0f1923] px-4 py-2 rounded-lg hover:bg-[#e8c47a] transition-colors cursor-pointer"
          >
            Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
}
